export const roomAprice = 5000;
export const roomBprice = 5000;
export const taxRate = 0.16;
export const pageHeight = document.body.scrollHeight;

